import { render, staticRenderFns } from "./EditInformation.vue?vue&type=template&id=163e227a&scoped=true"
import script from "./EditInformation.vue?vue&type=script&lang=js"
export * from "./EditInformation.vue?vue&type=script&lang=js"
import style0 from "./EditInformation.vue?vue&type=style&index=0&id=163e227a&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e227a",
  null
  
)

export default component.exports